import React, { useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Layout, Input, Space,  Grid, Divider } from 'antd';
import { ButtonGroup, Button } from "@mui/material";
import EtfPositions from "../Position/EtfPositions";
import { sampleColors } from "../../../utils/colors";
import Placeholder from "../../../components/Placeholder";
import { updateEtfMatrixConfig } from "../../../store/slices/appState.slice";
import {AddRounded, DeleteForeverRounded, DragHandleRounded} from "@mui/icons-material";
import { extractUniqueSectors } from "../utils";
import EtfSearch from "./EtfSearch";
const { useBreakpoint } = Grid;


const EtfList = ({tickers})=>{
    console.log(tickers)
    return (
        <Space direction={'vertical'}>
            {tickers.map(ticker => (
                <Space>
                    <DragHandleRounded/>
                    {ticker.symbol.toUpperCase()}
                </Space>
            ))}
        </Space>
    )

}

const EtfCollection = ({ selectedTickers, positions, onRemove, filters, etfColors, addTickerToSearch,
                           removeTickerFromSearch, clearTickersFromSearch, addEtfs, removeEtfs }) => {
    const dispatch = useDispatch();
    const breakPoints = useBreakpoint();

    let [checkboxProps, setCheckboxProps] = useState({ isChecked: false, symbol: null, tickerList: [] });
    const uniqueSectors = useMemo(() => extractUniqueSectors(positions), [positions]);
    const randomColors = useMemo(() => sampleColors(uniqueSectors.length, 'blue'), [uniqueSectors]);
    const sectorColors = useMemo(() => uniqueSectors.reduce((acc, sector, idx) => {
        acc[sector] = randomColors[idx];
        return acc;
    }, {}), [uniqueSectors, randomColors]);
    const positionTableMode = useSelector((state) => state.appStates.etfMatrix.positionTableMode);

    const onCheck = useCallback((etfSymbol) => {
        setCheckboxProps(prevProps => {
            if (prevProps.symbol === etfSymbol) {
                return {
                    isChecked: !prevProps.isChecked,
                    symbol: prevProps.isChecked ? null : etfSymbol,
                    tickerList: prevProps.isChecked ? [] : positions[etfSymbol].holdings
                };
            } else {
                return {
                    isChecked: true,
                    symbol: etfSymbol,
                    tickerList: positions[etfSymbol].holdings
                };
            }
        });
    }, [positions]);

    const togglePositionTableMode = () => {
        dispatch(updateEtfMatrixConfig({ positionTableMode: positionTableMode === 'trunc' ? 'full' : 'trunc' }));
    };

    return (
        <Layout>
            {breakPoints.lg && (
                <Layout.Sider width={300} style={{ background: "#fff", padding: '1% 10px' }}>
                    <EtfSearch addTickerToSearch={addTickerToSearch}
                               removeTickerFromSearch={removeTickerFromSearch}
                               clearTickersFromSearch={clearTickersFromSearch}
                               filters={filters}
                    />
                    <Divider/>
                    <EtfList tickers={selectedTickers}/>
                </Layout.Sider>
            )}
            <Layout.Content style={{ padding: '1%' }}>
                <div className={'round-2 p-1 bordered'}>
                    <Row className={'px-1'} justify={'start'}>
                        <ButtonGroup className={'mb-2'}>
                            <Button startIcon={<AddRounded/>} className={'square'} variant={'contained'} color="primary" onClick={addEtfs}>Add ETFs</Button>
                            <Button className={'square'} onClick={togglePositionTableMode} variant={'outlined'} color={positionTableMode === 'trunc' ? 'secondary' : 'primary'}>
                                {positionTableMode === 'trunc' ? 'Expand Tables' : "Collapse Tables"}
                            </Button>
                            <Button className={'square'} startIcon={<DeleteForeverRounded/>} variant={'outlined'} color="primary" onClick={removeEtfs}>Reset</Button>

                        </ButtonGroup>
                    </Row>
                    <Row gutter={[4, 4]} wrap={true} justify={'start'}>
                        {selectedTickers.map((ticker, index) => {
                            // Calculate the group based on the index (every 4 tickers)
                            const group = Math.floor(index / 4);

                            // Determine if we should stripe based on even or odd indexes
                            const shouldStripeEven = group % 2 === 0; // even groups stripe even indexes, odd groups stripe odd indexes
                            const isStriped = shouldStripeEven ? index % 2 === 0 : index % 2 !== 0;

                            return (
                                <Col key={ticker.symbol} xs={24} lg={12} xl={8} xxl={6}>
                                    {positions[ticker.symbol] ? (
                                        <EtfPositions
                                            etf={positions[ticker.symbol]}
                                            onRemove={() => onRemove(ticker)}
                                            checkboxProps={checkboxProps}
                                            onCheck={() => onCheck(ticker.symbol)}
                                            sectorColors={sectorColors}
                                            filters={filters}
                                            etfColor={etfColors[ticker.symbol]}
                                            background={isStriped ? '#fff' : '#f9f9f9'}
                                        />
                                    ) : <Placeholder text={'No ETF Data'} />}
                                </Col>
                            );
                        })}
                    </Row>

                </div>
            </Layout.Content>
        </Layout>
    );
};

export default EtfCollection;
